import 'components/chatSettings/chatSettings.scss';
import { ENGT_CHAT } from 'js/bot.model';
import './languagePreference.scss';

export const LanguagePreferenceTemplate = (model) => {
	const optionsData = model.languages;

	const header = ENGT_CHAT.get('GENERIC_STRINGS')?.['LANGUAGE_PREFERENCE'] || 'Language Preference';
	const desc = ENGT_CHAT.get('GENERIC_STRINGS')?.['CHOOSE_LANGUAGE'] || 'Choose your language preference:';

	const OptionHtml = (option) =>
		/* html */
		`<div class="engt-bot-lang">
            <input 
                type="radio" 
                id="engt-bot-lang-${option?.langCode}" 
                name="bot-language" 
                value="${option?.langName}"
				data-bot-langCode="${option?.langCode}"
            />
            <label for="engt-bot-lang-${option?.langCode}">${option?.langName}</label>
        </div>
 
`;
	const getMenuOptions = (allOptions = []) => {
		let allOptionsHtml = '';
		allOptions.map((opt) => (allOptionsHtml += OptionHtml(opt)));
		return allOptionsHtml;
	};

	const allMenuHTML = getMenuOptions(optionsData);

	/* html */
	const html = `
			<div class="engt-lang-settings-wrap">
				<div class="engt-bot-lang-description">${desc}</div>
				<div id="engtBotLanguagesHolder" class="engt-bot-lang-options">
					${allMenuHTML}
				</div>
			</div>
			<div class="engt-lang-settings-cta"></div>
	`;
	return html;
};
